import { Link } from 'react-router-dom';

const MCPServer = () => {
    return (
        <section className="pt-20 md:pt-24 pb-3 md:pb-4">
            <div className="w-full px-4 lg:px-0">
                <div className="w-full lg:w-[70%] lg:max-w-[1440px] mx-auto">
                    <div className="shadow-xl rounded-xl border-2 border-blue-100 overflow-hidden flex flex-col lg:flex-row min-h-[220px]">
                        {/* Left: text content */}
                        <div className="flex-1 bg-white px-6 py-8 sm:px-10 sm:py-10 flex flex-col justify-center gap-5">
                            <div>
                                <h3 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-3">
                                    MEFS MCP Server
                                </h3>
                                <p className="text-gray-600 text-sm sm:text-base leading-relaxed mb-3">
                                    MEFS MCP Server enables AI agents to seamlessly connect to the MEMO decentralized
                                    network, providing intelligent agents like OpenClaw with truly secure and persistent
                                    memory storage. Leveraging standardized Upload/Retrieve interfaces, it achieves
                                    efficient flow of generative content and private key-level sovereignty protection.
                                </p>
                                <p className="text-gray-500 text-sm">
                                    · Seamless Integration &nbsp;&nbsp; · Lasting Memories &nbsp;&nbsp; · Ultimate Privacy.
                                </p>
                            </div>
                            <div className="flex flex-wrap gap-3">
                                <a
                                    href="https://memolabs.gitbook.io/memo-gitbook/memo-aiagent/mefs-mcp-server"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="px-5 py-2 bg-blue-500 hover:bg-blue-600 text-white text-sm font-semibold rounded-md transition flex items-center gap-2"
                                >
                                    Deploy Now
                                    <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
                                    </svg>
                                </a>
                                <a
                                    href="https://github.com/memoio/mefs-mcp-server"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="px-5 py-2 border border-gray-300 hover:border-blue-400 text-gray-700 hover:text-blue-500 text-sm font-semibold rounded-md transition flex items-center gap-2"
                                >
                                    <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M12 0C5.374 0 0 5.373 0 12c0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23A11.509 11.509 0 0112 5.803c1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576C20.566 21.797 24 17.3 24 12c0-6.627-5.373-12-12-12z" />
                                    </svg>
                                    View Github
                                </a>
                                <Link
                                    to="/mcp-server"
                                    className="px-5 py-2 border border-blue-400 text-blue-500 hover:bg-blue-50 text-sm font-semibold rounded-md transition flex items-center gap-2"
                                >
                                    Learn More
                                    <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
                                    </svg>
                                </Link>
                            </div>
                        </div>

                        {/* Right: dark visual panel */}
                        <div
                            className="hidden lg:flex flex-shrink-0 w-[340px] xl:w-[400px] items-center justify-center"
                            style={{
                                background: 'linear-gradient(135deg, #0f172a 0%, #1e3a5f 50%, #1a4080 100%)',
                            }}
                        >
                            <div className="text-center px-8">
                                <div className="w-16 h-16 bg-blue-500 bg-opacity-20 rounded-2xl flex items-center justify-center mx-auto mb-4 border border-blue-400 border-opacity-30">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="w-8 h-8 text-blue-300" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09z" />
                                    </svg>
                                </div>
                                <p className="text-blue-200 text-sm font-mono">
                                    MCP · MEFS · AI Agents
                                </p>
                                <p className="text-blue-400 text-xs mt-2 font-mono opacity-70">
                                    Decentralized Storage
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default MCPServer;
